import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { matchesString } from "LIB/filters";
import {
  Pagination,
  SearchFilter,
  FilterSelect,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import { Search as SearchReceiving } from "MODULES/shared/components";
import { CLEAR_FILTERS_TEXT } from "APP_ROOT/constants";
import Table from "./Table";
import {
  receivingDashboardOrders,
  virtualReceivingDashboardOrders
} from "./pagination";
import { resetDiscrepancies } from "../actions";

const filters = [
  {
    label: "PO's",
    filters: { table: "purchase_order_line_items" }
  },
  {
    label: "LPO's",
    filters: { table: "lots" }
  },
  {
    label: "RO's",
    filters: { table: "repair_order_line_items" }
  },
  {
    label: "Store Transfers",
    filters: { table: "inventory_transfer_orders" }
  },
  {
    label: "Exchanges",
    filters: { table: "sales_order_line_items" }
  },
  {
    label: "Managed Repairs",
    filters: { table: "managed_repair_order_line_items" }
  },
  {
    label: "RMA's",
    filters: { table: "rmas" }
  },
  {
    label: "In Receiving Process",
    filters: { in_receiving_process: true },
    hr: true
  },
  {
    label: CLEAR_FILTERS_TEXT,
    filters: { table: null, in_receiving_process: undefined }
  }
];

const filterTags = [
  {
    label: "PO's",
    key: "table",
    matchesTarget: matchesString("purchase_order_line_items")
  },
  {
    label: "LPO's",
    key: "table",
    matchesTarget: matchesString("lots")
  },
  {
    label: "RO's",
    key: "table",
    matchesTarget: matchesString("repair_order_line_items")
  },
  {
    label: "Store Transfers",
    key: "table",
    matchesTarget: matchesString("inventory_transfer_orders")
  },
  {
    label: "Exchanges",
    key: "table",
    matchesTarget: matchesString("sales_order_line_items")
  },
  {
    label: "Managed Repairs",
    key: "table",
    matchesTarget: matchesString("managed_repair_order_line_items")
  },
  {
    label: "RMA's",
    key: "table",
    matchesTarget: matchesString("rmas")
  },
  {
    label: "In Receiving Process",
    key: "in_receiving_process"
  }
];

export class Search extends PureComponent {
  static propTypes = {
    openCreate: PropTypes.func.isRequired,
    openAndSetRecord: PropTypes.func.isRequired,
    setRemoveItem: PropTypes.func.isRequired,
    virtual: PropTypes.bool
  };

  constructor(props) {
    super();
    this.search = props.virtual
      ? virtualReceivingDashboardOrders
      : receivingDashboardOrders;
  }

  render() {
    const { openCreate, openAndSetRecord, setRemoveItem, virtual } = this.props;
    const title = virtual
      ? "Virtual Inbound Open Orders"
      : "Inbound Open Orders";

    const filteredFilters = virtual
      ? filters
      : filters.filter(f => f.label !== "Show Store Transfers");

    return (
      <SearchReceiving search={this.search} syncWithUrl>
        {searchProps => (
          <div>
            {setRemoveItem(searchProps.pageActions.removeItem)}
            <div className="form-group form-group-searchbar has-feedback has-feedback-left">
              <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
              <div className="input-group">
                <SearchFilter
                  {...searchProps}
                  placeholder="Search by typing a company name, part number, reference number or AWB #..."
                />
                <FilterSelect
                  {...searchProps}
                  filters={filteredFilters}
                  right
                />
                <span className="input-group-btn">
                  <button
                    onClick={openCreate}
                    className="btn btn-info"
                    type="button"
                  >
                    <i className="fa fa-fw fa-plus" />
                    Receive New
                  </button>
                </span>
              </div>
            </div>
            <TitleWithFilters
              {...searchProps}
              title={title}
              filters={filterTags}
            />
            <Table
              openModal={openAndSetRecord}
              {...searchProps}
              virtual={virtual}
            />
            <Pagination {...searchProps} />
          </div>
        )}
      </SearchReceiving>
    );
  }
}

export default connect(undefined, {
  reset: resetDiscrepancies
})(Search);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Dashboard/Search.jsx